<script>
import BfhsButton from '@components/bfhs/bfhs-button'

export default {
    name: 'BfhsTile',
    components: { BfhsButton },
    props: {
        bfh: {
            type: Object,
            default: () => {},
        },
    },
}
</script>

<template>
    <div class="slider">
        <div class="image-container">
            <img
                class="image"
                :src="bfh.image.url"
                :alt="bfh.image.heading"
            >
        </div>
        <div class="inner">
            <div class="section">
                <h3
                    v-if="bfh.heading"
                    class="title"
                >{{ bfh.heading }}</h3>
                <h4
                    v-if="bfh.subheading"
                    class="subtitle"
                >{{ bfh.subheading }}</h4>
                <BfhsButton
                    v-if="bfh.primary_action"
                    class="button"
                    :title="bfh.heading"
                    :action="bfh.primary_action"
                    type="nadir"
                    size="small"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.slider {
    position: relative;
    width: 100%;
    min-height: 120px;
    aspect-ratio: 9 / 1;
    overflow: hidden;
    border-radius: 20px;

    @include desktop {
        min-height: unset;
        aspect-ratio: 16 / 9;
    }
}

.image-container {
    @include fill;
}

.image  {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right center;
}

.inner {
    @include fill;

    z-index: 1;
}

.section {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: $s-s $s-m;

    @include desktop {
        padding: $s-xl;
    }
}

.title {
    @extend %h6;

    max-width: 220px;
    margin: 0;
    font-weight: 800;
    line-height: 1;
}

.subtitle {
    @extend %contentTitleS;

    margin: 0;
    margin-top: $s-xxs;
}

.button {
    margin-top: auto;
}

</style>
